module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/LA-Juvie-Yard2_BW-p-130x130q80-07b4f5a9c0fd8d94d11749dfd6f00185.jpg";